module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ack"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "30",
      "src": "images/eer-kaiulani-ornament.jpg",
      "width": "61"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerkaiulani0008#rack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("It seems fitting to open with a word of gratitude. First, I thank two knowledgeable and gracious historians, R. Kawika Makanani of the Kamehameha School and Holly McEldowney of Hawaii’s State Historic Preservation Division, for their eye-opening discussions of the continually evolving interpretations of Hawaii’s past. I owe a great debt to each for their input, especially on the presentation of the islands’ history in "), _c('a', {
    attrs: {
      "href": "#/eerkaiulani0014#ch01"
    }
  }, [_vm._v("Chapter One")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("On a more personal note, thanks to Lorrie Lazar, without whom no words would appear on these pages, and to Jenny Lazar, who gave the manuscript an early read through a teenager’s eyes.")]), _vm._v(" "), _c('p', [_vm._v("Thanks to Mary Ann O’Roark for suggestions and support every step of the way, and to my wonderful husband, Robert Scott, my anchor in every storm.")]), _vm._v(" "), _c('p', [_vm._v("Thanks, too, to all those who recognized the importance of Ka‘iulani’s story: Susan Cohen, a sane voice in a crazy profession, who has somehow become the official agent of Princess Ka‘iulani; to Amy DeVries for commissioning this book, Mary Hietbrink for strengthening it, Judy Zylstra for standing behind it, and Gayle Brown and Klaas Wolterstorff for the special design.")]), _vm._v(" "), _c('p', [_vm._v("Mahalo Nui!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-106b14fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-kaiulani-0009.vue
// module id = 78
// module chunks = 0